import { createApp } from 'vue';
import Page from './Page.vue'; // Importa el componente raíz de la página de pago
import '$src/assets/style.css'; // Importa CSS global/compartido

createApp(Page).mount('#app');
